import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import SkeletonLoading from 'helpers/loading/skeletonLoading';

const Component = lazy(() => import('components/claas-connect-accounts-list'));

const ClaasConnectAccountsList = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<SkeletonLoading rows={6} />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default ClaasConnectAccountsList;
